export const FirebaseConfig = {
	"projectId": "fasterandes-com-app",
	"appId": "1:80172956597:web:799265107cc790bf82b7fc",
	"databaseURL": "https://fasterandes-com-app-default-rtdb.firebaseio.com",
	"storageBucket": "fasterandes-com-app.appspot.com",
	"locationId": "us-east4",
	"apiKey": "AIzaSyAWzbCRsobfbbqWv3uI4JA0yFWGZWekulo",
	"authDomain": "fasterandes-com-app.firebaseapp.com",
	"messagingSenderId": "80172956597",
	"measurementId": "G-8HBXTVR424"
};